//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface AccessSignatureRequestModel {
  /** The duration the link will remain valid. Default is 5 minutes. */
  durationInMinutes?: number;
}

export interface AddDeliveryPortalRecipientModel {
  name?: string | undefined;
  email?: string | undefined;
  /** 

1 = FullAccess

2 = Payer */
  role?: PortalSecurityRole;
}

export interface Address {
  street1?: string | undefined;
  street2?: string | undefined;
  city?: string | undefined;
  /** 

1 = Alabama

2 = Alaska

3 = Arizona

4 = Arkansas

5 = California

6 = Colorado

7 = Connecticut

8 = Delaware

9 = Florida

10 = Georgia

11 = Hawaii

12 = Idaho

13 = Illinois

14 = Indiana

15 = Iowa

16 = Kansas

17 = Kentucky

18 = Louisiana

19 = Maine

20 = Maryland

21 = Massachusetts

22 = Michigan

23 = Minnesota

24 = Mississippi

25 = Missouri

26 = Montana

27 = Nebraska

28 = Nevada

29 = NewHampshire

30 = NewJersey

31 = NewMexico

32 = NewYork

33 = NorthCarolina

34 = NorthDakota

35 = Ohio

36 = Oklahoma

37 = Oregon

38 = Pennsylvania

39 = RhodeIsland

40 = SouthCarolina

41 = SouthDakota

42 = Tennessee

43 = Texas

44 = Utah

45 = Vermont

46 = Virginia

47 = Washington

48 = WestVirginia

49 = Wisconsin

50 = Wyoming

51 = DistrictOfColumbia

70 = UsTerritories

71 = Other */
  state?: State | undefined;
  /** 

1 = UnitedStates */
  country?: Country | undefined;
  zipCode?: string | undefined;
}

export interface AddressModel {
  street1?: string | undefined;
  street2?: string | undefined;
  city?: string | undefined;
  /** 

1 = Alabama

2 = Alaska

3 = Arizona

4 = Arkansas

5 = California

6 = Colorado

7 = Connecticut

8 = Delaware

9 = Florida

10 = Georgia

11 = Hawaii

12 = Idaho

13 = Illinois

14 = Indiana

15 = Iowa

16 = Kansas

17 = Kentucky

18 = Louisiana

19 = Maine

20 = Maryland

21 = Massachusetts

22 = Michigan

23 = Minnesota

24 = Mississippi

25 = Missouri

26 = Montana

27 = Nebraska

28 = Nevada

29 = NewHampshire

30 = NewJersey

31 = NewMexico

32 = NewYork

33 = NorthCarolina

34 = NorthDakota

35 = Ohio

36 = Oklahoma

37 = Oregon

38 = Pennsylvania

39 = RhodeIsland

40 = SouthCarolina

41 = SouthDakota

42 = Tennessee

43 = Texas

44 = Utah

45 = Vermont

46 = Virginia

47 = Washington

48 = WestVirginia

49 = Wisconsin

50 = Wyoming

51 = DistrictOfColumbia

70 = UsTerritories

71 = Other */
  state?: State | undefined;
  /** 

1 = UnitedStates */
  country?: Country | undefined;
  zipCode?: string | undefined;
}

/** 1 = ServePortExchange 2 = ServePortEmail 3 = ServePortFax 4 = ManualEmail 5 = ManualFax 6 = ManualMail 7 = ManualVerifiedDelivery 8 = ManualOther */
export enum AnswerDeliveryMethod {
  ServePortExchange = 1,
  ServePortEmail = 2,
  ServePortFax = 3,
  ManualEmail = 4,
  ManualFax = 5,
  ManualMail = 6,
  ManualVerifiedDelivery = 7,
  ManualOther = 8
}

export interface ApiError {
  error?: ErrorDetail | undefined;
}

export interface CompanyPicklistSettingsModel {
  enabled?: boolean;
  picklistIds?: number[] | undefined;
}

/** 1 = UnitedStates */
export enum Country {
  UnitedStates = 1
}

export interface CreateIntakePortalModel {
  isAgencyPortal?: boolean;
  companyId?: number | undefined;
  companyName?: string | undefined;
  title?: string | undefined;
  shortName?: string | undefined;
  isActive?: boolean;
  customDomain?: string | undefined;
  urlPath?: string | undefined;
  description?: string | undefined;
  instructions?: string | undefined;
  excludeFromRecentPortals?: boolean;
  authorizedDomains?: string[] | undefined;
  sensitiveFields?: FormField[] | undefined;
}

export interface CreateOrganizationModel {
  name?: string | undefined;
}

export interface CreateRegisteredAgencyModel {
  name?: string | undefined;
  fein?: string | undefined;
  authorizedDomains?: string[] | undefined;
  /** 

1 = LawFirm

2 = StateOrLocal

3 = Federal

4 = Customer

5 = Other

6 = State

7 = Local

8 = ProSe */
  organizationType?: ServingPartyOrgType | undefined;
  address?: Address | undefined;
  contactName?: string | undefined;
  contactPhone?: string | undefined;
  contactEmail?: string | undefined;
  contactFax?: string | undefined;
  garnishmentDetails?: GarnishmentAgencyDetailsModel | undefined;
}

export interface CreateSubmissionBatchModel {
  intakePortalId?: number;
  intakeFormId?: number;
  submitterName?: string | undefined;
  values?: SubmissionValueModel[] | undefined;
  children?: SubmissionChildModel[] | undefined;
  consents?: SubmissionConsentModel[] | undefined;
  temporaryFileIds?: number[] | undefined;
}

export interface CreateSubmissionModel {
  intakePortalId?: number;
  intakeFormId?: number;
  submitterName?: string | undefined;
  values?: SubmissionValueModel[] | undefined;
  children?: SubmissionChildModel[] | undefined;
  consents?: SubmissionConsentModel[] | undefined;
  temporaryFileIds?: number[] | undefined;
}

export interface DeliveryPortalAcknowledgeInstructionsModel {
  name?: string | undefined;
  email?: string | undefined;
}

export interface DeliveryPortalAttachmentModel {
  id?: number;
  name?: string | undefined;
  sizeInBytes?: number;
  dateFirstDeliveredToPortal?: string | undefined;
  dateFirstAccessedByServingParty?: string | undefined;
  folderName?: string | undefined;
}

export interface DeliveryPortalDataModel {
  companyId?: number;
  companyEntityId?: number;
  companyEntityName?: string | undefined;
  companyEntityShortName?: string | undefined;
  expirationDate?: string;
  responseId?: string | undefined;
  recipients?: DeliveryPortalRecipientModel[] | undefined;
  receiptUrl?: string | undefined;
  supportName?: string | undefined;
  supportEmail?: string | undefined;
  invoiceContactName?: string | undefined;
  invoiceContactEmail?: string | undefined;
  isExpired?: boolean;
  requireOneTimePin?: boolean;
  oneTimePinExpirationDate?: string | undefined;
  pinDeliveryOptions?: DeliveryPortalPinDeliveryOption[] | undefined;
  safariId?: string | undefined;
  /** 

1 = DocumentRequest

2 = Garnishment

3 = Litigation

4 = Other */
  type?: MatterType;
  caseNumber?: string | undefined;
  documentTitle?: string | undefined;
  matterName?: string | undefined;
  dateReceived?: string | undefined;
  dateDue?: string | undefined;
  servingPartyContact?: string | undefined;
  servingPartyEmail?: string | undefined;
  servingPartyAdditionalEmail?: string | undefined;
  /** 

1 = LawFirm

2 = StateOrLocal

3 = Federal

4 = Customer

5 = Other

6 = State

7 = Local

8 = ProSe */
  servingPartyOrgType?: ServingPartyOrgType | undefined;
  servingPartyOrgName?: string | undefined;
  servingPartyOrgAddress?: AddressModel | undefined;
  servingPartyPhoneNumbers?: ServingPartyPhoneNumberModel[] | undefined;
  servingPartyInstructions?: string | undefined;
  servingPartyRequireInstructionAcknowledgment?: boolean;
  responseAttachments?: DeliveryPortalAttachmentModel[] | undefined;
  servedAttachments?: DeliveryPortalAttachmentModel[] | undefined;
  financialAttachments?: DeliveryPortalAttachmentModel[] | undefined;
  invoiceAmount?: number | undefined;
  prepaidAmount?: number | undefined;
  netDueAmount?: number | undefined;
  paymentId?: string | undefined;
  /** 

1 = NotStarted

2 = InProgress

3 = Succeeded

4 = Failed

5 = Cancelled */
  paymentStatus?: PaymentStatus;
  subjects?: DeliveryPortalSubjectModel[] | undefined;
  internalReferenceId?: string | undefined;
  isOutsideCouncilDelivery?: boolean;
  /** 

1 = None

2 = InternalReferenceId

3 = SafariId */
  portalReferenceField?: PortalReferenceField | undefined;
  isRollingProduction?: boolean;
  instructionsAcknowledgedByName?: string | undefined;
  instructionsAcknowledgedByEmail?: string | undefined;
  dateInstructionsAcknowledged?: string | undefined;
}

export interface DeliveryPortalPinDeliveryOption {
  id?: number;
  /** 

1 = Email

2 = Fax

3 = Sms */
  type?: OneTimePinCommunicationType;
  recipient?: string | undefined;
}

export interface DeliveryPortalRecipientModel {
  name?: string | undefined;
  email?: string | undefined;
  /** 

1 = FullAccess

2 = Payer */
  role?: PortalSecurityRole;
  canBeRemoved?: boolean;
  invitationDate?: string;
  invitationFailed?: boolean;
  invitationErrorMessage?: string | undefined;
}

export interface DeliveryPortalSubjectModel {
  name?: string | undefined;
}

export interface DeveloperException {
  readonly message?: string | undefined;
  source?: string | undefined;
  readonly stackTrace?: string | undefined;
  readonly innerException?: DeveloperException | undefined;
}

export interface DownloadLinkModel {
  id?: number;
  name?: string | undefined;
  contentType?: string | undefined;
  sizeInBytes?: number | undefined;
  linkUrl?: string | undefined;
  dateLinkExpires?: string;
}

export interface EnsureUserAuthModel {
  email: string;
}

/** 0 = Unknown 1 = BadInput 2 = ConcurrencyError 3 = NoRecordFound 4 = PaymentRequired 5 = Forbidden 6 = TooManyRequests 7 = RetryAfter 8 = ClientDisconnect 9 = NotAuthorized */
export enum ErrorCode {
  Unknown = 0,
  BadInput = 1,
  ConcurrencyError = 2,
  NoRecordFound = 3,
  PaymentRequired = 4,
  Forbidden = 5,
  TooManyRequests = 6,
  RetryAfter = 7,
  ClientDisconnect = 8,
  NotAuthorized = 9
}

export interface ErrorDetail {
  /** 

0 = Unknown

1 = BadInput

2 = ConcurrencyError

3 = NoRecordFound

4 = PaymentRequired

5 = Forbidden

6 = TooManyRequests

7 = RetryAfter

8 = ClientDisconnect

9 = NotAuthorized */
  code?: ErrorCode;
  message?: string | undefined;
  details?: ErrorDetail[] | undefined;
  target?: string | undefined;
  developerException?: DeveloperException | undefined;
}

/** 1 = Text_SingleLine 2 = Text_MultiLine 3 = Phone 4 = Date 5 = Email 6 = YesNo 7 = Currency 8 = Picklist_Dropdown 9 = Picklist_Radio 10 = Typeahead 11 = Picklist_Checkbox_Multiselect 12 = FileUpload 13 = Button */
export enum FieldType {
  Text_SingleLine = 1,
  Text_MultiLine = 2,
  Phone = 3,
  Date = 4,
  Email = 5,
  YesNo = 6,
  Currency = 7,
  Picklist_Dropdown = 8,
  Picklist_Radio = 9,
  Typeahead = 10,
  Picklist_Checkbox_Multiselect = 11,
  FileUpload = 12,
  Button = 13
}

export interface FileLinkModel {
  id?: number;
  name?: string | undefined;
  contentType?: string | undefined;
  sizeInBytes?: number;
  linkUrl?: string | undefined;
  dateLinkExpires?: string;
}

export interface FileModel {
  id?: number;
  name?: string | undefined;
  contentType?: string | undefined;
  sizeInBytes?: number;
}

/** 1 = CaseNumber 2 = EntityServed_CompanyEntityId 3 = StateReceived 4 = EntityServed_OtherNameServed 5 = DateFiled 6 = Plaintiffs 7 = Defendants 8 = DocumentTitle 9 = InternalReferenceId 10 = MatterName 11 = FinancialNotes 12 = OtherInfo1 13 = ForumSameAsIssuingAuthority 14 = OtherInfo2 15 = ClientMatterNumber 16 = AgencyServedCompanyEntity 30 = DateToReturn 31 = DateResponseDue 32 = LegalAuthorityTypes 33 = LegalAuthorityText 34 = CaseType 35 = CaseSubtypes 36 = CaseSubtypeText 50 = ServingParty_Contact 51 = ServingParty_Email 52 = ServingParty_Phone 53 = ServingParty_PhoneExt 54 = ServingParty_Mobile 55 = ServingParty_Fax 56 = ServingParty_AdditionalEmail 57 = ServingParty_OrgType 58 = ServingParty_OrgName 60 = ServingParty_OrgAddress_Street1 61 = ServingParty_OrgAddress_Street2 62 = ServingParty_OrgAddress_City 63 = ServingParty_OrgAddress_State 64 = ServingParty_OrgAddress_Country 65 = ServingParty_OrgAddress_ZipCode 90 = IssuingAuthorityType 91 = IssuingAuthorityName 92 = IssuingAuthorityAddress_Street1 93 = IssuingAuthorityAddress_Street2 94 = IssuingAuthorityAddress_City 95 = IssuingAuthorityAddress_State 96 = IssuingAuthorityAddress_Country 97 = IssuingAuthorityAddress_ZipCode 110 = ForumTypeAndName 111 = ForumContactAddress_Street1 112 = ForumContactAddress_Street2 113 = ForumContactAddress_City 114 = ForumContactAddress_State 115 = ForumContactAddress_Country 116 = ForumContactAddress_ZipCode 130 = Subjects_Name 131 = Subjects_TaxId 132 = Subjects_OriginationDate 133 = Subjects_Address_Street1 134 = Subjects_Address_Street2 135 = Subjects_Address_City 136 = Subjects_Address_State 137 = Subjects_Address_Country 138 = Subjects_Address_ZipCode 139 = Subjects_DocumentsRequestedText 140 = Subjects_CustomerId 141 = Subjects_Notes 142 = Subjects_DateRangeStart 143 = Subjects_DateRangeEnd 144 = Subjects_Type 145 = Subjects_DocumentsRequestedTypes 146 = Subjects_First 147 = Subjects_Middle 148 = Subjects_Last 149 = Subjects_Suffix 150 = Subjects_Alias 200 = DateAnswerDue 201 = DatePaymentDue 202 = GarnishmentLevyOrderAmount 220 = CreditorName 221 = CreditorAddress_Street1 222 = CreditorAddress_Street2 223 = CreditorAddress_City 224 = CreditorAddress_State 225 = CreditorAddress_Country 226 = CreditorAddress_ZipCode 240 = PayeeIdentity 242 = PayeeName 243 = PayeeAddress_Street1 244 = PayeeAddress_Street2 245 = PayeeAddress_City 246 = PayeeAddress_State 247 = PayeeAddress_Country 248 = PayeeAddress_ZipCode 260 = GarnishmentAccountNumber 261 = GarnishmentAccountType 262 = GarnishmentAccountSeizedAmount 263 = GarnishmentAccountNotes 264 = GarnishmentAccountLocationState 300 = LitigationAmountClaimed 301 = LitigationJudgmentSought 320 = DateReceived 321 = DocReceivedBy 322 = MethodOfService 323 = OrgUnitOrDivision 330 = LegalOrderFeeOrPrepaidAmount 331 = LegalOrderFeeOrPrepaidCheckNumber 400 = ServedDocument 401 = SupportingDocument 410 = ServingParty_SaveToMyProfile 420 = CustomDocument1 421 = CustomDocument2 422 = CustomDocument3 423 = CustomDocument4 424 = CustomDocument5 425 = CustomDocument6 426 = CustomDocument7 427 = CustomDocument8 428 = CustomDocument9 429 = CustomDocument10 */
export enum FormField {
  CaseNumber = 1,
  EntityServed_CompanyEntityId = 2,
  StateReceived = 3,
  EntityServed_OtherNameServed = 4,
  DateFiled = 5,
  Plaintiffs = 6,
  Defendants = 7,
  DocumentTitle = 8,
  InternalReferenceId = 9,
  MatterName = 10,
  FinancialNotes = 11,
  OtherInfo1 = 12,
  ForumSameAsIssuingAuthority = 13,
  OtherInfo2 = 14,
  ClientMatterNumber = 15,
  AgencyServedCompanyEntity = 16,
  DateToReturn = 30,
  DateResponseDue = 31,
  LegalAuthorityTypes = 32,
  LegalAuthorityText = 33,
  CaseType = 34,
  CaseSubtypes = 35,
  CaseSubtypeText = 36,
  ServingParty_Contact = 50,
  ServingParty_Email = 51,
  ServingParty_Phone = 52,
  ServingParty_PhoneExt = 53,
  ServingParty_Mobile = 54,
  ServingParty_Fax = 55,
  ServingParty_AdditionalEmail = 56,
  ServingParty_OrgType = 57,
  ServingParty_OrgName = 58,
  ServingParty_OrgAddress_Street1 = 60,
  ServingParty_OrgAddress_Street2 = 61,
  ServingParty_OrgAddress_City = 62,
  ServingParty_OrgAddress_State = 63,
  ServingParty_OrgAddress_Country = 64,
  ServingParty_OrgAddress_ZipCode = 65,
  IssuingAuthorityType = 90,
  IssuingAuthorityName = 91,
  IssuingAuthorityAddress_Street1 = 92,
  IssuingAuthorityAddress_Street2 = 93,
  IssuingAuthorityAddress_City = 94,
  IssuingAuthorityAddress_State = 95,
  IssuingAuthorityAddress_Country = 96,
  IssuingAuthorityAddress_ZipCode = 97,
  ForumTypeAndName = 110,
  ForumContactAddress_Street1 = 111,
  ForumContactAddress_Street2 = 112,
  ForumContactAddress_City = 113,
  ForumContactAddress_State = 114,
  ForumContactAddress_Country = 115,
  ForumContactAddress_ZipCode = 116,
  Subjects_Name = 130,
  Subjects_TaxId = 131,
  Subjects_OriginationDate = 132,
  Subjects_Address_Street1 = 133,
  Subjects_Address_Street2 = 134,
  Subjects_Address_City = 135,
  Subjects_Address_State = 136,
  Subjects_Address_Country = 137,
  Subjects_Address_ZipCode = 138,
  Subjects_DocumentsRequestedText = 139,
  Subjects_CustomerId = 140,
  Subjects_Notes = 141,
  Subjects_DateRangeStart = 142,
  Subjects_DateRangeEnd = 143,
  Subjects_Type = 144,
  Subjects_DocumentsRequestedTypes = 145,
  Subjects_First = 146,
  Subjects_Middle = 147,
  Subjects_Last = 148,
  Subjects_Suffix = 149,
  Subjects_Alias = 150,
  DateAnswerDue = 200,
  DatePaymentDue = 201,
  GarnishmentLevyOrderAmount = 202,
  CreditorName = 220,
  CreditorAddress_Street1 = 221,
  CreditorAddress_Street2 = 222,
  CreditorAddress_City = 223,
  CreditorAddress_State = 224,
  CreditorAddress_Country = 225,
  CreditorAddress_ZipCode = 226,
  PayeeIdentity = 240,
  PayeeName = 242,
  PayeeAddress_Street1 = 243,
  PayeeAddress_Street2 = 244,
  PayeeAddress_City = 245,
  PayeeAddress_State = 246,
  PayeeAddress_Country = 247,
  PayeeAddress_ZipCode = 248,
  GarnishmentAccountNumber = 260,
  GarnishmentAccountType = 261,
  GarnishmentAccountSeizedAmount = 262,
  GarnishmentAccountNotes = 263,
  GarnishmentAccountLocationState = 264,
  LitigationAmountClaimed = 300,
  LitigationJudgmentSought = 301,
  DateReceived = 320,
  DocReceivedBy = 321,
  MethodOfService = 322,
  OrgUnitOrDivision = 323,
  LegalOrderFeeOrPrepaidAmount = 330,
  LegalOrderFeeOrPrepaidCheckNumber = 331,
  ServedDocument = 400,
  SupportingDocument = 401,
  ServingParty_SaveToMyProfile = 410,
  CustomDocument1 = 420,
  CustomDocument2 = 421,
  CustomDocument3 = 422,
  CustomDocument4 = 423,
  CustomDocument5 = 424,
  CustomDocument6 = 425,
  CustomDocument7 = 426,
  CustomDocument8 = 427,
  CustomDocument9 = 428,
  CustomDocument10 = 429
}

export interface GarnishmentAgencyDetailsModel {
  /** 

1 = ServePortExchange

2 = ServePortEmail

3 = ServePortFax

4 = ManualEmail

5 = ManualFax

6 = ManualMail

7 = ManualVerifiedDelivery

8 = ManualOther */
  answerDeliveryMethod?: AnswerDeliveryMethod;
  answerEmail?: string | undefined;
  answerFax?: string | undefined;
  /** 

1 = Restrain

2 = IndefiniteHold */
  requestActionType?: GarnishmentRequestActionType | undefined;
  /** 

1 = PointInTime

2 = Continuous */
  holdType?: GarnishmentHoldType | undefined;
  /** 

1 = Full

2 = Double */
  holdAmountType?: GarnishmentHoldAmountType | undefined;
  minimumThresholdAmount?: number | undefined;
  exceptionAmount?: number | undefined;
  statutoryAuthority?: string | undefined;
  daysPaymentDueAfterDateReceived?: number | undefined;
  /** 

1 = NewLevyAmount

2 = AmountToSubtractFromWhatWasSeized

3 = AmountToSubtractFromOriginalLevy */
  maintenanceOrderReleaseAmountType?: MaintenanceOrderReleaseAmountType | undefined;
  enableAutoPayment?: boolean;
  /** 

1 = Mail

2 = HandDelivered

3 = RegisteredAgent

4 = Email

5 = CertifiedMail

6 = OvernightDelivery

7 = Fax

8 = ServePort

9 = ServePortExchange

10 = ServePortAgencyPortal */
  methodOfService?: MethodOfService | undefined;
}

/** 1 = Full 2 = Double */
export enum GarnishmentHoldAmountType {
  Full = 1,
  Double = 2
}

/** 1 = PointInTime 2 = Continuous */
export enum GarnishmentHoldType {
  PointInTime = 1,
  Continuous = 2
}

/** 1 = Restrain 2 = IndefiniteHold */
export enum GarnishmentRequestActionType {
  Restrain = 1,
  IndefiniteHold = 2
}

export interface GetDownloadLinkModel {
  /** Duration the link remains active. Default is 5 minutes. */
  durationInMinutes?: number;
  /** If true, the link's content-disposition header will be set to `inline` otherwise `attachment` */
  openInBrowser?: boolean;
}

export interface IdResultModel {
  id?: number;
}

export interface IntakeChildRelationshipModel {
  /** 

1 = Subject

2 = Account */
  child?: MatterChild;
  singularName?: string | undefined;
  pluralName?: string | undefined;
  isRequired?: boolean;
  maxChildren?: number;
  fields?: IntakeFieldModel[] | undefined;
}

export interface IntakeConsentModel {
  name?: string | undefined;
  text?: string | undefined;
}

export interface IntakeFieldModel {
  /** 

1 = CaseNumber

2 = EntityServed_CompanyEntityId

3 = StateReceived

4 = EntityServed_OtherNameServed

5 = DateFiled

6 = Plaintiffs

7 = Defendants

8 = DocumentTitle

9 = InternalReferenceId

10 = MatterName

11 = FinancialNotes

12 = OtherInfo1

13 = ForumSameAsIssuingAuthority

14 = OtherInfo2

15 = ClientMatterNumber

16 = AgencyServedCompanyEntity

30 = DateToReturn

31 = DateResponseDue

32 = LegalAuthorityTypes

33 = LegalAuthorityText

34 = CaseType

35 = CaseSubtypes

36 = CaseSubtypeText

50 = ServingParty_Contact

51 = ServingParty_Email

52 = ServingParty_Phone

53 = ServingParty_PhoneExt

54 = ServingParty_Mobile

55 = ServingParty_Fax

56 = ServingParty_AdditionalEmail

57 = ServingParty_OrgType

58 = ServingParty_OrgName

60 = ServingParty_OrgAddress_Street1

61 = ServingParty_OrgAddress_Street2

62 = ServingParty_OrgAddress_City

63 = ServingParty_OrgAddress_State

64 = ServingParty_OrgAddress_Country

65 = ServingParty_OrgAddress_ZipCode

90 = IssuingAuthorityType

91 = IssuingAuthorityName

92 = IssuingAuthorityAddress_Street1

93 = IssuingAuthorityAddress_Street2

94 = IssuingAuthorityAddress_City

95 = IssuingAuthorityAddress_State

96 = IssuingAuthorityAddress_Country

97 = IssuingAuthorityAddress_ZipCode

110 = ForumTypeAndName

111 = ForumContactAddress_Street1

112 = ForumContactAddress_Street2

113 = ForumContactAddress_City

114 = ForumContactAddress_State

115 = ForumContactAddress_Country

116 = ForumContactAddress_ZipCode

130 = Subjects_Name

131 = Subjects_TaxId

132 = Subjects_OriginationDate

133 = Subjects_Address_Street1

134 = Subjects_Address_Street2

135 = Subjects_Address_City

136 = Subjects_Address_State

137 = Subjects_Address_Country

138 = Subjects_Address_ZipCode

139 = Subjects_DocumentsRequestedText

140 = Subjects_CustomerId

141 = Subjects_Notes

142 = Subjects_DateRangeStart

143 = Subjects_DateRangeEnd

144 = Subjects_Type

145 = Subjects_DocumentsRequestedTypes

146 = Subjects_First

147 = Subjects_Middle

148 = Subjects_Last

149 = Subjects_Suffix

150 = Subjects_Alias

200 = DateAnswerDue

201 = DatePaymentDue

202 = GarnishmentLevyOrderAmount

220 = CreditorName

221 = CreditorAddress_Street1

222 = CreditorAddress_Street2

223 = CreditorAddress_City

224 = CreditorAddress_State

225 = CreditorAddress_Country

226 = CreditorAddress_ZipCode

240 = PayeeIdentity

242 = PayeeName

243 = PayeeAddress_Street1

244 = PayeeAddress_Street2

245 = PayeeAddress_City

246 = PayeeAddress_State

247 = PayeeAddress_Country

248 = PayeeAddress_ZipCode

260 = GarnishmentAccountNumber

261 = GarnishmentAccountType

262 = GarnishmentAccountSeizedAmount

263 = GarnishmentAccountNotes

264 = GarnishmentAccountLocationState

300 = LitigationAmountClaimed

301 = LitigationJudgmentSought

320 = DateReceived

321 = DocReceivedBy

322 = MethodOfService

323 = OrgUnitOrDivision

330 = LegalOrderFeeOrPrepaidAmount

331 = LegalOrderFeeOrPrepaidCheckNumber

400 = ServedDocument

401 = SupportingDocument

410 = ServingParty_SaveToMyProfile

420 = CustomDocument1

421 = CustomDocument2

422 = CustomDocument3

423 = CustomDocument4

424 = CustomDocument5

425 = CustomDocument6

426 = CustomDocument7

427 = CustomDocument8

428 = CustomDocument9

429 = CustomDocument10 */
  field?: FormField;
  /** 

1 = Text_SingleLine

2 = Text_MultiLine

3 = Phone

4 = Date

5 = Email

6 = YesNo

7 = Currency

8 = Picklist_Dropdown

9 = Picklist_Radio

10 = Typeahead

11 = Picklist_Checkbox_Multiselect

12 = FileUpload

13 = Button */
  fieldType?: FieldType;
  /** 

1 = ContactInfo

2 = ServiceInfo

3 = Documents

4 = ScopeOfRequest

5 = AdditionalInfo

6 = CreditorAndPayee

7 = Forum

8 = IssuingAuthority

9 = Financial */
  section?: IntakeFormSection;
  displayName?: string | undefined;
  isRequired?: boolean;
  description?: string | undefined;
  defaultValue?: string | undefined;
  allowedValues?: string[] | undefined;
  fileUploadSettings?: IntakeFileUploadSettingsModel | undefined;
}

export interface IntakeFileUploadSettingsModel {
  maxFiles?: number;
  allowedExtensions?: string[] | undefined;
  folderName?: string | undefined;
}

export interface IntakeFormLayoutModel {
  isCustom?: boolean;
  widgets?: IntakeFormLayoutWidgetModel[] | undefined;
}

export interface IntakeFormLayoutWidgetMarginModel {
  top?: number | undefined;
  right?: number | undefined;
  bottom?: number | undefined;
  left?: number | undefined;
}

export interface IntakeFormLayoutWidgetModel {
  id?: number;
  /** 

1 = Section

2 = Group

3 = Field

4 = Element

5 = ChildRelationship */
  type?: IntakeFormLayoutWidgetType;
  label?: string | undefined;
  hideLabel?: boolean;
  description?: string | undefined;
  placeholder?: string | undefined;
  /** 

1 = NoRowBreak

2 = RowRightPadded

3 = RowLeftPadded */
  rowType?: IntakeFormLayoutWidgetRowType;
  columnSpan?: number | undefined;
  margin?: IntakeFormLayoutWidgetMarginModel | undefined;
  widgets?: IntakeFormLayoutWidgetModel[] | undefined;
}

/** 1 = NoRowBreak 2 = RowRightPadded 3 = RowLeftPadded */
export enum IntakeFormLayoutWidgetRowType {
  NoRowBreak = 1,
  RowRightPadded = 2,
  RowLeftPadded = 3
}

/** 1 = Section 2 = Group 3 = Field 4 = Element 5 = ChildRelationship */
export enum IntakeFormLayoutWidgetType {
  Section = 1,
  Group = 2,
  Field = 3,
  Element = 4,
  ChildRelationship = 5
}

export interface IntakeFormListModel {
  id?: number;
  matterSubtypeId?: number | undefined;
  matterSubtypeDisplayName?: string | undefined;
}

export interface IntakeFormModel {
  id?: number;
  matterSubtypeId?: number | undefined;
  /** 

1 = DocumentRequest

2 = Garnishment

3 = Litigation

4 = Other */
  matterType?: MatterType;
  matterSubtypeDisplayName?: string | undefined;
  acknowledgmentCoverLetterTemplate?: string | undefined;
  allowBatchSubmission?: boolean;
  fields?: IntakeFieldModel[] | undefined;
  childRelationships?: IntakeChildRelationshipModel[] | undefined;
  consents?: IntakeConsentModel[] | undefined;
  layout?: IntakeFormLayoutModel | undefined;
}

export interface IntakeFormModelPagedResponseModel {
  totalCount?: number;
  items?: IntakeFormModel[] | undefined;
}

/** 1 = ContactInfo 2 = ServiceInfo 3 = Documents 4 = ScopeOfRequest 5 = AdditionalInfo 6 = CreditorAndPayee 7 = Forum 8 = IssuingAuthority 9 = Financial */
export enum IntakeFormSection {
  ContactInfo = 1,
  ServiceInfo = 2,
  Documents = 3,
  ScopeOfRequest = 4,
  AdditionalInfo = 5,
  CreditorAndPayee = 6,
  Forum = 7,
  IssuingAuthority = 8,
  Financial = 9
}

export interface IntakePortalListModel {
  id?: number;
  isAgencyPortal?: boolean;
  companyId?: number | undefined;
  companyName?: string | undefined;
  title?: string | undefined;
  shortName?: string | undefined;
  isActive?: boolean;
  customDomain?: string | undefined;
  urlPath?: string | undefined;
  excludeFromRecentPortals?: boolean;
  authorizedDomains?: string[] | undefined;
  forms?: IntakeFormListModel[] | undefined;
}

export interface IntakePortalListModelPagedResponseModel {
  totalCount?: number;
  items?: IntakePortalListModel[] | undefined;
}

export interface IntakePortalModel {
  id?: number;
  isAgencyPortal?: boolean;
  companyId?: number | undefined;
  companyName?: string | undefined;
  title?: string | undefined;
  shortName?: string | undefined;
  isActive?: boolean;
  customDomain?: string | undefined;
  urlPath?: string | undefined;
  description?: string | undefined;
  instructions?: string | undefined;
  excludeFromRecentPortals?: boolean;
  authorizedDomains?: string[] | undefined;
  sensitiveFields?: FormField[] | undefined;
}

export interface ListRegisteredAgencyModel {
  id?: number;
  name?: string | undefined;
  fein?: string | undefined;
  authorizedDomains?: string[] | undefined;
}

export interface ListRegisteredAgencyModelPagedResponseModel {
  totalCount?: number;
  items?: ListRegisteredAgencyModel[] | undefined;
}

/** 1 = NewLevyAmount 2 = AmountToSubtractFromWhatWasSeized 3 = AmountToSubtractFromOriginalLevy */
export enum MaintenanceOrderReleaseAmountType {
  NewLevyAmount = 1,
  AmountToSubtractFromWhatWasSeized = 2,
  AmountToSubtractFromOriginalLevy = 3
}

/** 1 = Incomplete 2 = Clean 3 = MalwareFound 4 = Skipped */
export enum MalwareScanStatus {
  Incomplete = 1,
  Clean = 2,
  MalwareFound = 3,
  Skipped = 4
}

/** 1 = Subject 2 = Account */
export enum MatterChild {
  Subject = 1,
  Account = 2
}

/** 1 = DocumentRequest 2 = Garnishment 3 = Litigation 4 = Other */
export enum MatterType {
  DocumentRequest = 1,
  Garnishment = 2,
  Litigation = 3,
  Other = 4
}

/** 1 = Mail 2 = HandDelivered 3 = RegisteredAgent 4 = Email 5 = CertifiedMail 6 = OvernightDelivery 7 = Fax 8 = ServePort 9 = ServePortExchange 10 = ServePortAgencyPortal */
export enum MethodOfService {
  Mail = 1,
  HandDelivered = 2,
  RegisteredAgent = 3,
  Email = 4,
  CertifiedMail = 5,
  OvernightDelivery = 6,
  Fax = 7,
  ServePort = 8,
  ServePortExchange = 9,
  ServePortAgencyPortal = 10
}

/** 1 = Email 2 = Fax 3 = Sms */
export enum OneTimePinCommunicationType {
  Email = 1,
  Fax = 2,
  Sms = 3
}

export interface Operation {
  value?: any | undefined;
  path?: string | undefined;
  op?: string | undefined;
  from?: string | undefined;
}

export interface OperationModel {
  id?: string;
  lastUpdatedDateTime?: string;
  name?: string | undefined;
  /** 

0 = Pending

1 = Success

2 = Failure */
  status?: OperationStatus;

  [key: string]: any;
}

/** 0 = Pending 1 = Success 2 = Failure */
export enum OperationStatus {
  Pending = 0,
  Success = 1,
  Failure = 2
}

export interface OrganizationModel {
  id?: number;
  name?: string | undefined;
}

export interface OrganizationModelPagedResponseModel {
  totalCount?: number;
  items?: OrganizationModel[] | undefined;
}

/** 1 = NotStarted 2 = InProgress 3 = Succeeded 4 = Failed 5 = Cancelled */
export enum PaymentStatus {
  NotStarted = 1,
  InProgress = 2,
  Succeeded = 3,
  Failed = 4,
  Cancelled = 5
}

export interface PhoneNumberModel {
  number?: string | undefined;
  extension?: string | undefined;
  /** 

1 = Office

2 = Mobile

3 = Fax */
  type?: PhoneType | undefined;
  isPrimary?: boolean;
}

/** 1 = Office 2 = Mobile 3 = Fax */
export enum PhoneType {
  Office = 1,
  Mobile = 2,
  Fax = 3
}

export interface PicklistResultModel {
  /** 

3 = PhoneTypes

4 = FormFields

5 = MatterChildren

6 = SubmissionStatuses

7 = MalwareScanStatuses

8 = IntakeFormSection

9 = FieldTypes

10 = IntakeFormLayoutWidgetType

11 = IntakeFormLayoutWidgetRowType

12 = LayoutElement

13 = SubmissionBatchStatuses

14 = GarnishmentHoldAmountTypes

15 = MaintenanceOrderReleaseAmountTypes

100 = Countries

101 = States

102 = MatterTypes

103 = MatterSubtypes

104 = ServingPartyOrgTypes

105 = CompanyEntities

106 = IssuingAuthorityTypes

107 = PayeeIdentities

108 = ResponseDocumentTypes

109 = LegalAuthorityTypes

110 = SubjectTypes

111 = CaseTypes

112 = CivilCaseSubtypes

113 = CriminalCaseSubtypes

114 = RegulatoryCaseSubtypes

115 = OtherCaseSubtypes

116 = MethodOfServices

117 = AllCaseSubtypes

118 = AnswerDeliveryMethods

119 = GarnishmentHoldTypes

120 = GarnishmentRequestActionTypes

121 = AgencyServableCompanyEntities */
  type?: PicklistType;
  values?: PicklistValueModel[] | undefined;
}

export interface PicklistResultModelPagedResponseModel {
  totalCount?: number;
  items?: PicklistResultModel[] | undefined;
}

/** 3 = PhoneTypes 4 = FormFields 5 = MatterChildren 6 = SubmissionStatuses 7 = MalwareScanStatuses 8 = IntakeFormSection 9 = FieldTypes 10 = IntakeFormLayoutWidgetType 11 = IntakeFormLayoutWidgetRowType 12 = LayoutElement 13 = SubmissionBatchStatuses 14 = GarnishmentHoldAmountTypes 15 = MaintenanceOrderReleaseAmountTypes 100 = Countries 101 = States 102 = MatterTypes 103 = MatterSubtypes 104 = ServingPartyOrgTypes 105 = CompanyEntities 106 = IssuingAuthorityTypes 107 = PayeeIdentities 108 = ResponseDocumentTypes 109 = LegalAuthorityTypes 110 = SubjectTypes 111 = CaseTypes 112 = CivilCaseSubtypes 113 = CriminalCaseSubtypes 114 = RegulatoryCaseSubtypes 115 = OtherCaseSubtypes 116 = MethodOfServices 117 = AllCaseSubtypes 118 = AnswerDeliveryMethods 119 = GarnishmentHoldTypes 120 = GarnishmentRequestActionTypes 121 = AgencyServableCompanyEntities */
export enum PicklistType {
  PhoneTypes = 3,
  FormFields = 4,
  MatterChildren = 5,
  SubmissionStatuses = 6,
  MalwareScanStatuses = 7,
  IntakeFormSection = 8,
  FieldTypes = 9,
  IntakeFormLayoutWidgetType = 10,
  IntakeFormLayoutWidgetRowType = 11,
  LayoutElement = 12,
  SubmissionBatchStatuses = 13,
  GarnishmentHoldAmountTypes = 14,
  MaintenanceOrderReleaseAmountTypes = 15,
  Countries = 100,
  States = 101,
  MatterTypes = 102,
  MatterSubtypes = 103,
  ServingPartyOrgTypes = 104,
  CompanyEntities = 105,
  IssuingAuthorityTypes = 106,
  PayeeIdentities = 107,
  ResponseDocumentTypes = 108,
  LegalAuthorityTypes = 109,
  SubjectTypes = 110,
  CaseTypes = 111,
  CivilCaseSubtypes = 112,
  CriminalCaseSubtypes = 113,
  RegulatoryCaseSubtypes = 114,
  OtherCaseSubtypes = 115,
  MethodOfServices = 116,
  AllCaseSubtypes = 117,
  AnswerDeliveryMethods = 118,
  GarnishmentHoldTypes = 119,
  GarnishmentRequestActionTypes = 120,
  AgencyServableCompanyEntities = 121
}

export interface PicklistValueModel {
  id?: string | undefined;
  name?: string | undefined;

  [key: string]: any;
}

export interface PicklistValueModelPagedResponseModel {
  totalCount?: number;
  items?: PicklistValueModel[] | undefined;
}

/** 1 = None 2 = InternalReferenceId 3 = SafariId */
export enum PortalReferenceField {
  None = 1,
  InternalReferenceId = 2,
  SafariId = 3
}

/** 1 = FullAccess 2 = Payer */
export enum PortalSecurityRole {
  FullAccess = 1,
  Payer = 2
}

export interface ProfileModel {
  id?: number;
  authUserId?: number;
  name?: string | undefined;
  email?: string | undefined;
  /** 

1 = LawFirm

2 = StateOrLocal

3 = Federal

4 = Customer

5 = Other

6 = State

7 = Local

8 = ProSe */
  orgType?: ServingPartyOrgType | undefined;
  orgName?: string | undefined;
  orgAddress?: AddressModel | undefined;
  phoneNumbers?: PhoneNumberModel[] | undefined;
}

export interface RecentIntakePortalModel {
  intakePortalId?: number;
}

export interface RegisteredAgencyModel {
  id?: number;
  name?: string | undefined;
  fein?: string | undefined;
  authorizedDomains?: string[] | undefined;
  /** 

1 = LawFirm

2 = StateOrLocal

3 = Federal

4 = Customer

5 = Other

6 = State

7 = Local

8 = ProSe */
  organizationType?: ServingPartyOrgType | undefined;
  address?: Address | undefined;
  contactName?: string | undefined;
  contactPhone?: string | undefined;
  contactEmail?: string | undefined;
  contactFax?: string | undefined;
  garnishmentDetails?: GarnishmentAgencyDetailsModel | undefined;
}

export interface RemoveDeliveryPortalRecipientModel {
  email?: string | undefined;
}

export interface ResponseZipLinkModel {
  linkUrl?: string | undefined;
  dateLinkExpires?: string;
}

export interface SearchOrganizationsModel {
  query?: string | undefined;
  orderBy?: string | undefined;
  skip?: number | undefined;
  top?: number | undefined;
}

/** 1 = LawFirm 2 = StateOrLocal 3 = Federal 4 = Customer 5 = Other 6 = State 7 = Local 8 = ProSe */
export enum ServingPartyOrgType {
  LawFirm = 1,
  StateOrLocal = 2,
  Federal = 3,
  Customer = 4,
  Other = 5,
  State = 6,
  Local = 7,
  ProSe = 8
}

export interface ServingPartyPhoneNumberModel {
  number?: string | undefined;
  extension?: string | undefined;
  /** 

1 = Office

2 = Mobile

3 = Fax */
  type?: ServingPartyPhoneType | undefined;
  isPrimary?: boolean;
}

/** 1 = Office 2 = Mobile 3 = Fax */
export enum ServingPartyPhoneType {
  Office = 1,
  Mobile = 2,
  Fax = 3
}

export enum SignalRSubmissionBatchEvent {
  ReceiveSubmissionBatchStatus = 'ReceiveSubmissionBatchStatus'
}

export enum SignalRSubmissionEvent {
  ReceiveSubmissionStatus = 'ReceiveSubmissionStatus',
  ReceiveMalwareScanStatus = 'ReceiveMalwareScanStatus'
}

/** 1 = Alabama 2 = Alaska 3 = Arizona 4 = Arkansas 5 = California 6 = Colorado 7 = Connecticut 8 = Delaware 9 = Florida 10 = Georgia 11 = Hawaii 12 = Idaho 13 = Illinois 14 = Indiana 15 = Iowa 16 = Kansas 17 = Kentucky 18 = Louisiana 19 = Maine 20 = Maryland 21 = Massachusetts 22 = Michigan 23 = Minnesota 24 = Mississippi 25 = Missouri 26 = Montana 27 = Nebraska 28 = Nevada 29 = NewHampshire 30 = NewJersey 31 = NewMexico 32 = NewYork 33 = NorthCarolina 34 = NorthDakota 35 = Ohio 36 = Oklahoma 37 = Oregon 38 = Pennsylvania 39 = RhodeIsland 40 = SouthCarolina 41 = SouthDakota 42 = Tennessee 43 = Texas 44 = Utah 45 = Vermont 46 = Virginia 47 = Washington 48 = WestVirginia 49 = Wisconsin 50 = Wyoming 51 = DistrictOfColumbia 70 = UsTerritories 71 = Other */
export enum State {
  Alabama = 1,
  Alaska = 2,
  Arizona = 3,
  Arkansas = 4,
  California = 5,
  Colorado = 6,
  Connecticut = 7,
  Delaware = 8,
  Florida = 9,
  Georgia = 10,
  Hawaii = 11,
  Idaho = 12,
  Illinois = 13,
  Indiana = 14,
  Iowa = 15,
  Kansas = 16,
  Kentucky = 17,
  Louisiana = 18,
  Maine = 19,
  Maryland = 20,
  Massachusetts = 21,
  Michigan = 22,
  Minnesota = 23,
  Mississippi = 24,
  Missouri = 25,
  Montana = 26,
  Nebraska = 27,
  Nevada = 28,
  NewHampshire = 29,
  NewJersey = 30,
  NewMexico = 31,
  NewYork = 32,
  NorthCarolina = 33,
  NorthDakota = 34,
  Ohio = 35,
  Oklahoma = 36,
  Oregon = 37,
  Pennsylvania = 38,
  RhodeIsland = 39,
  SouthCarolina = 40,
  SouthDakota = 41,
  Tennessee = 42,
  Texas = 43,
  Utah = 44,
  Vermont = 45,
  Virginia = 46,
  Washington = 47,
  WestVirginia = 48,
  Wisconsin = 49,
  Wyoming = 50,
  DistrictOfColumbia = 51,
  UsTerritories = 70,
  Other = 71
}

export interface SubmissionBatchModel {
  id?: number;
  batchNumber?: string | undefined;
  intakePortalId?: number;
  registeredAgencyId?: number | undefined;
  companyId?: number;
  companyName?: string | undefined;
  companyEntityId?: number | undefined;
  companyEntityName?: string | undefined;
  /** 

1 = DocumentRequest

2 = Garnishment

3 = Litigation

4 = Other */
  matterType?: MatterType;
  matterSubtypeId?: number;
  matterSubtypeDisplayName?: string | undefined;
  submitterName?: string | undefined;
  dateOfSubmission?: string;
  /** 

1 = Started

2 = Complete */
  status?: SubmissionBatchStatus;
  submissions?: SubmissionModel[] | undefined;
  acknowledgmentOfReceipt?: FileModel | undefined;
}

/** 1 = Started 2 = Complete */
export enum SubmissionBatchStatus {
  Started = 1,
  Complete = 2
}

export interface SubmissionBatchSubmissionStatusChangedEvent {
  submissionId?: number;
  /** 

1 = Processing_MalwareScan

2 = Processing_SubmittingData

3 = Success

4 = Failed */
  status?: SubmissionStatus;
}

export interface SubmissionChildModel {
  /** 

1 = Subject

2 = Account */
  child?: MatterChild;
  values?: SubmissionValueModel[] | undefined;
}

export interface SubmissionConsentModel {
  name?: string | undefined;
  text?: string | undefined;
}

export interface SubmissionFileModel {
  readonly isSupporting?: boolean;
  /** 

1 = CaseNumber

2 = EntityServed_CompanyEntityId

3 = StateReceived

4 = EntityServed_OtherNameServed

5 = DateFiled

6 = Plaintiffs

7 = Defendants

8 = DocumentTitle

9 = InternalReferenceId

10 = MatterName

11 = FinancialNotes

12 = OtherInfo1

13 = ForumSameAsIssuingAuthority

14 = OtherInfo2

15 = ClientMatterNumber

16 = AgencyServedCompanyEntity

30 = DateToReturn

31 = DateResponseDue

32 = LegalAuthorityTypes

33 = LegalAuthorityText

34 = CaseType

35 = CaseSubtypes

36 = CaseSubtypeText

50 = ServingParty_Contact

51 = ServingParty_Email

52 = ServingParty_Phone

53 = ServingParty_PhoneExt

54 = ServingParty_Mobile

55 = ServingParty_Fax

56 = ServingParty_AdditionalEmail

57 = ServingParty_OrgType

58 = ServingParty_OrgName

60 = ServingParty_OrgAddress_Street1

61 = ServingParty_OrgAddress_Street2

62 = ServingParty_OrgAddress_City

63 = ServingParty_OrgAddress_State

64 = ServingParty_OrgAddress_Country

65 = ServingParty_OrgAddress_ZipCode

90 = IssuingAuthorityType

91 = IssuingAuthorityName

92 = IssuingAuthorityAddress_Street1

93 = IssuingAuthorityAddress_Street2

94 = IssuingAuthorityAddress_City

95 = IssuingAuthorityAddress_State

96 = IssuingAuthorityAddress_Country

97 = IssuingAuthorityAddress_ZipCode

110 = ForumTypeAndName

111 = ForumContactAddress_Street1

112 = ForumContactAddress_Street2

113 = ForumContactAddress_City

114 = ForumContactAddress_State

115 = ForumContactAddress_Country

116 = ForumContactAddress_ZipCode

130 = Subjects_Name

131 = Subjects_TaxId

132 = Subjects_OriginationDate

133 = Subjects_Address_Street1

134 = Subjects_Address_Street2

135 = Subjects_Address_City

136 = Subjects_Address_State

137 = Subjects_Address_Country

138 = Subjects_Address_ZipCode

139 = Subjects_DocumentsRequestedText

140 = Subjects_CustomerId

141 = Subjects_Notes

142 = Subjects_DateRangeStart

143 = Subjects_DateRangeEnd

144 = Subjects_Type

145 = Subjects_DocumentsRequestedTypes

146 = Subjects_First

147 = Subjects_Middle

148 = Subjects_Last

149 = Subjects_Suffix

150 = Subjects_Alias

200 = DateAnswerDue

201 = DatePaymentDue

202 = GarnishmentLevyOrderAmount

220 = CreditorName

221 = CreditorAddress_Street1

222 = CreditorAddress_Street2

223 = CreditorAddress_City

224 = CreditorAddress_State

225 = CreditorAddress_Country

226 = CreditorAddress_ZipCode

240 = PayeeIdentity

242 = PayeeName

243 = PayeeAddress_Street1

244 = PayeeAddress_Street2

245 = PayeeAddress_City

246 = PayeeAddress_State

247 = PayeeAddress_Country

248 = PayeeAddress_ZipCode

260 = GarnishmentAccountNumber

261 = GarnishmentAccountType

262 = GarnishmentAccountSeizedAmount

263 = GarnishmentAccountNotes

264 = GarnishmentAccountLocationState

300 = LitigationAmountClaimed

301 = LitigationJudgmentSought

320 = DateReceived

321 = DocReceivedBy

322 = MethodOfService

323 = OrgUnitOrDivision

330 = LegalOrderFeeOrPrepaidAmount

331 = LegalOrderFeeOrPrepaidCheckNumber

400 = ServedDocument

401 = SupportingDocument

410 = ServingParty_SaveToMyProfile

420 = CustomDocument1

421 = CustomDocument2

422 = CustomDocument3

423 = CustomDocument4

424 = CustomDocument5

425 = CustomDocument6

426 = CustomDocument7

427 = CustomDocument8

428 = CustomDocument9

429 = CustomDocument10 */
  field?: FormField;
  /** 

1 = Incomplete

2 = Clean

3 = MalwareFound

4 = Skipped */
  malwareScanStatus?: MalwareScanStatus;
  id?: number;
  name?: string | undefined;
  contentType?: string | undefined;
  sizeInBytes?: number;
}

export interface SubmissionLookupModel {
  id?: number;
  intakePortalId?: number;
  registeredAgencyId?: number | undefined;
  customDomain?: string | undefined;
}

export interface SubmissionModel {
  id?: number;
  intakePortalId?: number;
  registeredAgencyId?: number | undefined;
  companyId?: number;
  companyName?: string | undefined;
  companyEntityId?: number | undefined;
  companyEntityName?: string | undefined;
  matterId?: number | undefined;
  safariId?: string | undefined;
  /** 

1 = DocumentRequest

2 = Garnishment

3 = Litigation

4 = Other */
  matterType?: MatterType;
  matterSubtypeId?: number;
  matterSubtypeDisplayName?: string | undefined;
  submitterName?: string | undefined;
  dateOfSubmission?: string;
  /** 

1 = Processing_MalwareScan

2 = Processing_SubmittingData

3 = Success

4 = Failed */
  status?: SubmissionStatus;
  values?: SubmissionValueModel[] | undefined;
  children?: SubmissionChildModel[] | undefined;
  consents?: SubmissionConsentModel[] | undefined;
  attachments?: SubmissionFileModel[] | undefined;
  acknowledgmentOfReceipt?: FileModel | undefined;
}

/** 1 = Processing_MalwareScan 2 = Processing_SubmittingData 3 = Success 4 = Failed */
export enum SubmissionStatus {
  Processing_MalwareScan = 1,
  Processing_SubmittingData = 2,
  Success = 3,
  Failed = 4
}

export interface SubmissionValueModel {
  /** 

1 = CaseNumber

2 = EntityServed_CompanyEntityId

3 = StateReceived

4 = EntityServed_OtherNameServed

5 = DateFiled

6 = Plaintiffs

7 = Defendants

8 = DocumentTitle

9 = InternalReferenceId

10 = MatterName

11 = FinancialNotes

12 = OtherInfo1

13 = ForumSameAsIssuingAuthority

14 = OtherInfo2

15 = ClientMatterNumber

16 = AgencyServedCompanyEntity

30 = DateToReturn

31 = DateResponseDue

32 = LegalAuthorityTypes

33 = LegalAuthorityText

34 = CaseType

35 = CaseSubtypes

36 = CaseSubtypeText

50 = ServingParty_Contact

51 = ServingParty_Email

52 = ServingParty_Phone

53 = ServingParty_PhoneExt

54 = ServingParty_Mobile

55 = ServingParty_Fax

56 = ServingParty_AdditionalEmail

57 = ServingParty_OrgType

58 = ServingParty_OrgName

60 = ServingParty_OrgAddress_Street1

61 = ServingParty_OrgAddress_Street2

62 = ServingParty_OrgAddress_City

63 = ServingParty_OrgAddress_State

64 = ServingParty_OrgAddress_Country

65 = ServingParty_OrgAddress_ZipCode

90 = IssuingAuthorityType

91 = IssuingAuthorityName

92 = IssuingAuthorityAddress_Street1

93 = IssuingAuthorityAddress_Street2

94 = IssuingAuthorityAddress_City

95 = IssuingAuthorityAddress_State

96 = IssuingAuthorityAddress_Country

97 = IssuingAuthorityAddress_ZipCode

110 = ForumTypeAndName

111 = ForumContactAddress_Street1

112 = ForumContactAddress_Street2

113 = ForumContactAddress_City

114 = ForumContactAddress_State

115 = ForumContactAddress_Country

116 = ForumContactAddress_ZipCode

130 = Subjects_Name

131 = Subjects_TaxId

132 = Subjects_OriginationDate

133 = Subjects_Address_Street1

134 = Subjects_Address_Street2

135 = Subjects_Address_City

136 = Subjects_Address_State

137 = Subjects_Address_Country

138 = Subjects_Address_ZipCode

139 = Subjects_DocumentsRequestedText

140 = Subjects_CustomerId

141 = Subjects_Notes

142 = Subjects_DateRangeStart

143 = Subjects_DateRangeEnd

144 = Subjects_Type

145 = Subjects_DocumentsRequestedTypes

146 = Subjects_First

147 = Subjects_Middle

148 = Subjects_Last

149 = Subjects_Suffix

150 = Subjects_Alias

200 = DateAnswerDue

201 = DatePaymentDue

202 = GarnishmentLevyOrderAmount

220 = CreditorName

221 = CreditorAddress_Street1

222 = CreditorAddress_Street2

223 = CreditorAddress_City

224 = CreditorAddress_State

225 = CreditorAddress_Country

226 = CreditorAddress_ZipCode

240 = PayeeIdentity

242 = PayeeName

243 = PayeeAddress_Street1

244 = PayeeAddress_Street2

245 = PayeeAddress_City

246 = PayeeAddress_State

247 = PayeeAddress_Country

248 = PayeeAddress_ZipCode

260 = GarnishmentAccountNumber

261 = GarnishmentAccountType

262 = GarnishmentAccountSeizedAmount

263 = GarnishmentAccountNotes

264 = GarnishmentAccountLocationState

300 = LitigationAmountClaimed

301 = LitigationJudgmentSought

320 = DateReceived

321 = DocReceivedBy

322 = MethodOfService

323 = OrgUnitOrDivision

330 = LegalOrderFeeOrPrepaidAmount

331 = LegalOrderFeeOrPrepaidCheckNumber

400 = ServedDocument

401 = SupportingDocument

410 = ServingParty_SaveToMyProfile

420 = CustomDocument1

421 = CustomDocument2

422 = CustomDocument3

423 = CustomDocument4

424 = CustomDocument5

425 = CustomDocument6

426 = CustomDocument7

427 = CustomDocument8

428 = CustomDocument9

429 = CustomDocument10 */
  field?: FormField;
  value?: string | undefined;
}

export interface TemporaryFileModel {
  intakePortalId?: number;
  readonly isSupporting?: boolean;
  /** 

1 = CaseNumber

2 = EntityServed_CompanyEntityId

3 = StateReceived

4 = EntityServed_OtherNameServed

5 = DateFiled

6 = Plaintiffs

7 = Defendants

8 = DocumentTitle

9 = InternalReferenceId

10 = MatterName

11 = FinancialNotes

12 = OtherInfo1

13 = ForumSameAsIssuingAuthority

14 = OtherInfo2

15 = ClientMatterNumber

16 = AgencyServedCompanyEntity

30 = DateToReturn

31 = DateResponseDue

32 = LegalAuthorityTypes

33 = LegalAuthorityText

34 = CaseType

35 = CaseSubtypes

36 = CaseSubtypeText

50 = ServingParty_Contact

51 = ServingParty_Email

52 = ServingParty_Phone

53 = ServingParty_PhoneExt

54 = ServingParty_Mobile

55 = ServingParty_Fax

56 = ServingParty_AdditionalEmail

57 = ServingParty_OrgType

58 = ServingParty_OrgName

60 = ServingParty_OrgAddress_Street1

61 = ServingParty_OrgAddress_Street2

62 = ServingParty_OrgAddress_City

63 = ServingParty_OrgAddress_State

64 = ServingParty_OrgAddress_Country

65 = ServingParty_OrgAddress_ZipCode

90 = IssuingAuthorityType

91 = IssuingAuthorityName

92 = IssuingAuthorityAddress_Street1

93 = IssuingAuthorityAddress_Street2

94 = IssuingAuthorityAddress_City

95 = IssuingAuthorityAddress_State

96 = IssuingAuthorityAddress_Country

97 = IssuingAuthorityAddress_ZipCode

110 = ForumTypeAndName

111 = ForumContactAddress_Street1

112 = ForumContactAddress_Street2

113 = ForumContactAddress_City

114 = ForumContactAddress_State

115 = ForumContactAddress_Country

116 = ForumContactAddress_ZipCode

130 = Subjects_Name

131 = Subjects_TaxId

132 = Subjects_OriginationDate

133 = Subjects_Address_Street1

134 = Subjects_Address_Street2

135 = Subjects_Address_City

136 = Subjects_Address_State

137 = Subjects_Address_Country

138 = Subjects_Address_ZipCode

139 = Subjects_DocumentsRequestedText

140 = Subjects_CustomerId

141 = Subjects_Notes

142 = Subjects_DateRangeStart

143 = Subjects_DateRangeEnd

144 = Subjects_Type

145 = Subjects_DocumentsRequestedTypes

146 = Subjects_First

147 = Subjects_Middle

148 = Subjects_Last

149 = Subjects_Suffix

150 = Subjects_Alias

200 = DateAnswerDue

201 = DatePaymentDue

202 = GarnishmentLevyOrderAmount

220 = CreditorName

221 = CreditorAddress_Street1

222 = CreditorAddress_Street2

223 = CreditorAddress_City

224 = CreditorAddress_State

225 = CreditorAddress_Country

226 = CreditorAddress_ZipCode

240 = PayeeIdentity

242 = PayeeName

243 = PayeeAddress_Street1

244 = PayeeAddress_Street2

245 = PayeeAddress_City

246 = PayeeAddress_State

247 = PayeeAddress_Country

248 = PayeeAddress_ZipCode

260 = GarnishmentAccountNumber

261 = GarnishmentAccountType

262 = GarnishmentAccountSeizedAmount

263 = GarnishmentAccountNotes

264 = GarnishmentAccountLocationState

300 = LitigationAmountClaimed

301 = LitigationJudgmentSought

320 = DateReceived

321 = DocReceivedBy

322 = MethodOfService

323 = OrgUnitOrDivision

330 = LegalOrderFeeOrPrepaidAmount

331 = LegalOrderFeeOrPrepaidCheckNumber

400 = ServedDocument

401 = SupportingDocument

410 = ServingParty_SaveToMyProfile

420 = CustomDocument1

421 = CustomDocument2

422 = CustomDocument3

423 = CustomDocument4

424 = CustomDocument5

425 = CustomDocument6

426 = CustomDocument7

427 = CustomDocument8

428 = CustomDocument9

429 = CustomDocument10 */
  field?: FormField;
  /** 

1 = Incomplete

2 = Clean

3 = MalwareFound

4 = Skipped */
  malwareScanStatus?: MalwareScanStatus;
  id?: number;
  name?: string | undefined;
  contentType?: string | undefined;
  sizeInBytes?: number;
}

export interface UpdateIntakeFormModel {
  matterSubtypeId?: number | undefined;
  /** 

1 = DocumentRequest

2 = Garnishment

3 = Litigation

4 = Other */
  matterType?: MatterType;
  matterSubtypeDisplayName?: string | undefined;
  acknowledgmentCoverLetterTemplate?: string | undefined;
  allowBatchSubmission?: boolean;
  fields?: IntakeFieldModel[] | undefined;
  childRelationships?: IntakeChildRelationshipModel[] | undefined;
  consents?: IntakeConsentModel[] | undefined;
  customLayout?: IntakeFormLayoutModel | undefined;
}

export interface UpdateIntakePortalModel {
  companyName?: string | undefined;
  customDomain?: string | undefined;
  urlPath?: string | undefined;
  title?: string | undefined;
  shortName?: string | undefined;
  isActive?: boolean;
  description?: string | undefined;
  instructions?: string | undefined;
  excludeFromRecentPortals?: boolean;
  authorizedDomains?: string[] | undefined;
  sensitiveFields?: FormField[] | undefined;
}

export interface UpdateProfileModel {
  name?: string | undefined;
  /** 

1 = LawFirm

2 = StateOrLocal

3 = Federal

4 = Customer

5 = Other

6 = State

7 = Local

8 = ProSe */
  orgType?: ServingPartyOrgType | undefined;
  orgName?: string | undefined;
  orgAddress?: AddressModel | undefined;
  phoneNumbers?: PhoneNumberModel[] | undefined;
}

export interface Void {}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}
